export default "__VITE_ASSET__wijiLJdo__"